var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ height: _vm.$store.state.clientHeight + 'px' }),attrs:{"id":"app"}},[_c('el-scrollbar',{staticClass:"custom_scrollbar",staticStyle:{"height":"100%","ovflow-x":"hidden"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }